<template>
  <div class="alarmHistoryData mb-2">
    <div class="col-12 row text-center mx-0 table-responsive">
      <b-table
        :items="alarmHistoryDataItem"
        :fields="alarmHistoryDataFields"
        sticky-header="240px"
        :no-border-collapse="true"
        :class="{
          'alarmHistoryData-table-detail': alarmHistoryTableStyle == '',
          'machStatus-components-table':
            alarmHistoryTableStyle == 'machStatus-components-table',
        }"
        class="alarmHistoryData-table-detail-select"
      >
        <template #cell(alarmVideo)="row">
          <template v-if="row.item['alarmVideo'] == ''">無</template>
          <template v-else>
            <b-icon
              icon="cloud-download"
              aria-hidden="true"
              class="alarmHistoryData-icon"
              @click="JSdownloadfile(row.item['alarmVideo'])"
            ></b-icon>
          </template>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "alarmHistoryData",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      alarmHistoryDataFields: "alarmHistoryData/get_alarmHistoryDataFields",
      alarmHistoryDataItem: "alarmHistoryData/get_alarmHistoryDataItem",
      alarmHistoryTableStyle: "alarmHistoryData/get_alarmHistoryTableStyle",
      deviceName: "alarmHistoryData/get_deviceName",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
    }),
    JSdownloadfile(file) {
      let vm = this;
      console.log(file);
      vm.axios({
        url: `/ofco/site2/${vm.deviceName}/${file}`,
        method: "GET",
        responseType: "blob",
        onDownloadProgress: function (progressEvent) {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
      })
        .then((response) => {
          console.log(response);
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", file);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        })
        .catch(function (err) {
          console.log(err);
          console.log(err.response.status);
        });
    },
  },
};
</script>

<style>
</style>
<style lang="scss">
.alarmHistoryData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.alarmHistoryData-table-detail th,
.alarmHistoryData-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.alarmHistoryData-table-detail td {
  font-size: 1rem;
}
.alarmHistoryData-table-detail th:first-child,
.alarmHistoryData-table-detail td:first-child {
  border-left: 1px solid;
}
.alarmHistoryData-table-detail-select tr th:nth-child(1),
.alarmHistoryData-table-detail-select tr td:nth-child(1) {
  width: 115px;
  min-width: 115px;
  white-space: pre-line;
}
.alarmHistoryData-table-detail-select tr th:nth-child(2),
.alarmHistoryData-table-detail-select tr td:nth-child(2) {
  width: 200px;
  min-width: 200px;
  white-space: pre-line;
}
.alarmHistoryData-table-detail-select tr th:nth-child(3),
.alarmHistoryData-table-detail-select tr td:nth-child(3) {
  width: 115px;
  min-width: 115px;
}
.alarmHistoryData-table-detail-select tr th:nth-child(4),
.alarmHistoryData-table-detail-select tr td:nth-child(4) {
  width: 210px;
  min-width: 210px;
}
.alarmHistoryData-table-detail-select tr th:nth-child(5),
.alarmHistoryData-table-detail-select tr td:nth-child(5) {
  width: 210px;
  min-width: 210px;
}
.alarmHistoryData-table-detail-select tr th:nth-child(6),
.alarmHistoryData-table-detail-select tr td:nth-child(6) {
  width: 115px;
  min-width: 115px;
}
.alarmHistoryData-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.alarmHistoryData-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.alarmHistoryData-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}

.alarmHistoryData-icon {
  cursor: pointer;
}
.alarmHistoryData-icon:hover {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/alarmHistoryData.vue